import Frames from "@frog/source/utility/Frames.js"

export default {
    "static": require("./general-idle-0.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 100,
            "images": [
                require("./general-idle-0.png"),
                require("./general-idle-0.png"),
                require("./general-idle-0.png"),
                require("./general-idle-0.png"),
                require("./general-idle-0.png"),
                require("./general-idle-0.png"),
                require("./general-idle-0.png"),
                require("./general-idle-0.png"),
                require("./general-idle-1.png"),
                require("./general-idle-2.png"),
                require("./general-idle-3.png"),
                require("./general-idle-4.png"),
                require("./general-idle-5.png"),
                require("./general-idle-6.png"),
                require("./general-idle-7.png"),
                require("./general-idle-7.png"),
                require("./general-idle-7.png"),
                require("./general-idle-7.png"),
            ]
        })
    },
    "ready": {
        "frames": Frames.run({
            "tweentime": 60,
            "images": [
                require("./general-selected-2.png"),
                require("./general-selected-3.png"),
                require("./general-selected-4.png"),
                require("./general-selected-5.png"),
                require("./general-selected-5.png"),
                require("./general-selected-5.png"),
                require("./general-selected-5.png"),
                require("./general-selected-5.png"),
                require("./general-selected-5.png"),
                require("./general-selected-5.png"),
                require("./general-selected-5.png"),
                require("./general-selected-6.png"),
                require("./general-selected-7.png"),
                require("./general-selected-0.png"),
                require("./general-selected-0.png"),
                require("./general-selected-0.png"),
                require("./general-selected-0.png"),
                require("./general-selected-0.png"),
                require("./general-selected-0.png"),
                require("./general-selected-0.png"),
                require("./general-selected-0.png"),
                require("./general-selected-1.png"),
            ]
        })
    },
}
